import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import React from 'react';
import { FocusLockBackboneWrapper } from './focus-lock-backbone-wrapper';

export const focusLockDecorator = (View, focusLockOptions) => {
  const DecoratedFocusLockView = Backbone.View.extend({
    initialize(options) {
      this.options = options;
      this.eventsToActions = options.eventsToActions;
      this.focusLockOptions = focusLockOptions;
    },

    render() {
      ReactDOM.render(
        (
          <FocusLockBackboneWrapper
            focusLockProps={this.focusLockOptions}
            View={View}
            viewOptions={this.options}
            eventsToActions={this.eventsToActions}
          />
        ),
        this.el
      );

      return this;
    },

    remove() {
      ReactDOM.unmountComponentAtNode(this.el);
      Backbone.View.prototype.remove.call(this);
    },
  });

  return DecoratedFocusLockView;
};
